module.exports = __webpack_public_path__ + "img/circle-gray-highlight.ab06480c.svg";